import { Pipe, PipeTransform } from '@angular/core';
import {Conversation} from '../models/Conversation';

@Pipe({name: 'conversationIsSelected'})
export class ConversationIsSelectedPipe implements PipeTransform {
  transform(conversation: Conversation, selectedConversationIds: string[]): boolean {
    return selectedConversationIds.includes(conversation.id);
  }
}
